import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { faInfoCircle, faQuestionCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Subscription, Observable, of } from 'rxjs';
import * as _ from 'lodash';


import { Store, select } from '@ngrx/store';
import { State } from '../store/state';
import * as ClaimCmeCeActions from '../store/actions';
import {
    getLabAffiliations$,
    showConfirmation$,
    getAssignmentStatusCodeMessage$,
    selectClaimCmeCeSlice,
    getAssignmentStatusCode$,
    getAssignmentStatus$,
    hasError$,
    hasAffiliations$,
    getDerivedOrganization$,
    getAssignmentStatusCodeMessageType$,
    showHelp$,
    getContextualHelpHTML$,
} from '../store/selectors';
import { LabAffiliation } from '../data/models/lab-affiliation.model';
import { isNullOrUndefined } from 'util';
import { AssignmentStatusTypes, AssignmentStatusMessageTypes } from '../store/constants';
import { AppState } from '../../../../app/shared/store/app.reducer';
import { getUserFullName$ } from '../../../../app/auth/store/selectors/auth.selectors';
import { State as LoadingState } from '../../../../app/shared/store/loading-store/state';
import { isLoading } from '../../../../app/shared/store/loading-store/selectors';
import { AppConfig } from '../../../../app/config/app-config';
import { map, filter } from 'rxjs/operators';
import { State as ProgressState } from '../../../../../src/app/shared/store/progress-store/state';
import { isProcessing$ } from '../../../../../src/app/shared/store/progress-store/selectors';

@Component({
    selector: 'app-claim-cme-ce',
    templateUrl: './claim-cme-ce.component.html',
    styleUrls: ['./claim-cme-ce.component.css'],
})
export class ClaimCmeCeComponent implements OnInit, OnDestroy  {
    readonly ENTER_CAP_AND_KIT_TEXT = 'Enter Laboratory/Organization CAP # and Kit #';
    readonly ASSIGNMENT_STATUS_TYPES = AssignmentStatusTypes;
    readonly ASSIGNEMTN_STATUS_MESSAGE_TYPES = AssignmentStatusMessageTypes;
    ELSS_HOME_URL: string;
    CAP_HOME_URL: string;

    private readonly CAP_KIT_REGEX = '^[0-9]*$';

    isLoading$: Observable<boolean>;
    isProcessing$: Observable<boolean>;

    // faInfoCircle = faInfoCircle;/
    // faArrowLeft = faArrowLeft;
    // faQuestionCircle = faQuestionCircle;

    form: FormGroup;
    // Laboratory/Organization Options:
    laboratoryOrganizationOptions: any[];

    submitted = false;

    selectedOrganization: any;
    derivedOrganization$: Observable<LabAffiliation>;

    // Data:
    showConfirmation$: Observable<boolean>;
    assignmentStatus$: Observable<AssignmentStatusTypes>;
    assignmentStatusCodeMessage$: Observable<string>;
    assignmentStatusCodeMessageType$: Observable<AssignmentStatusMessageTypes>;

    contextualHelpHTML$: Observable<string>;

    showErrorModal$: Observable<boolean>;
    showHelpModal$: Observable<boolean>;

    constructor(
        private fb: FormBuilder,
        private store: Store<State>,
        private appStore: Store<AppState>,
        private loadingStore: Store<LoadingState>,
        private progressStore: Store<ProgressState>
    ) {}

    ngOnInit() {
        this.ELSS_HOME_URL = AppConfig.settings.elss.home;
        this.CAP_HOME_URL = AppConfig.settings.cap.home;

        this.form = this.fb.group({
            kitNumber: [
                '',
                [
                    Validators.required,
                    Validators.pattern(this.CAP_KIT_REGEX),
                    Validators.maxLength(8),
                    Validators.minLength(8),
                ],
            ],
            capNumber: [
                '',
                [
                    Validators.required,
                    Validators.pattern(this.CAP_KIT_REGEX),
                    Validators.maxLength(7),
                    Validators.minLength(7),
                ],
            ],
            organization: [''],
        });

        // Fetch Data:
        this.isLoading$ = this.loadingStore.pipe(select(isLoading));
        this.isProcessing$ = this.progressStore.pipe(select(isProcessing$));
        this.store.dispatch(new ClaimCmeCeActions.GetLabAffiliations());
        this.store.dispatch(new ClaimCmeCeActions.GetContextualHelp());
        this.showConfirmation$ = this.store.pipe(select(showConfirmation$));
        this.showHelpModal$ = this.store.pipe(select(showHelp$));
        this.assignmentStatus$ = this.store.pipe(select(getAssignmentStatus$));
        this.assignmentStatusCodeMessage$ = this.store.pipe(select(getAssignmentStatusCodeMessage$));
        this.assignmentStatusCodeMessageType$ = this.store.pipe(select(getAssignmentStatusCodeMessageType$));

        this.contextualHelpHTML$ = this.store.pipe(select(getContextualHelpHTML$));
        this.showErrorModal$ = this.store.pipe(select(hasError$));

        this.derivedOrganization$ = this.store.pipe(select(getDerivedOrganization$));
        this.derivedOrganization$
  .pipe(filter(lab => !!lab))
  .subscribe((lab) => {
    this.selectedOrganization = lab;
  });
        // Subscribe to Data:

        this.store
            .pipe(
                select(getLabAffiliations$),
                filter((affiliations) => !isNullOrUndefined(affiliations))
            )
            .subscribe((affiliations) => {
                this.laboratoryOrganizationOptions = affiliations;
                this.initForm();
            });
    }

    // Form:
    initForm() {
        this.selectedOrganization = _.get(this.laboratoryOrganizationOptions, '[0]', this.ENTER_CAP_AND_KIT_TEXT);

        // I'm not sure why this setTimeout is needed, but the template refuses to update if it's not here...
        setTimeout(() => {
            this.form.patchValue({ organization: this.selectedOrganization });
            this.form.patchValue({ capNumber: this.selectedOrganization.capNumber });
        }, 50);
    }

    onOrganizationChange(organizationValue: any) {
        if (organizationValue === this.ENTER_CAP_AND_KIT_TEXT) {
            this.form.controls.capNumber.enable();
            this.form.patchValue({ capNumber: '' });
        } else {
            this.form.controls.capNumber.disable();
            this.form.patchValue({ capNumber: this.selectedOrganization.capNumber });
        }
    }

    onSubmit() {
        this.submitted = true;

        if (this.capNumberHasErrors || this.kitNumberHasErrors) {
            return;
        }

        if (this.form.controls.organization.value === this.ENTER_CAP_AND_KIT_TEXT) {
            this.store.dispatch(new ClaimCmeCeActions.GetLabInfo({ capNumber: this.form.controls.capNumber.value }));
        } else {
            this.store.dispatch(new ClaimCmeCeActions.OpenConfirmationWindow());
        }
    }

    public checkLoadStatus(value: any): boolean {
        return value;
    }

    get kitNumberHasErrors(): boolean {
        const kitNumber = this.form.controls.kitNumber.value;

        return !kitNumber || kitNumber.length < 8;
    }

    get capNumberHasErrors(): boolean {
        const capNumber = this.form.controls.capNumber.value;

        return !capNumber || capNumber.length < 7;
    }

    // Modal Information:
    get userFullName$(): Observable<string> {
        return this.appStore.pipe(select(getUserFullName$));
    }

    get isAffiliated$(): Observable<boolean> {
        return this.store.pipe(select(hasAffiliations$));
    }

    get showAffiliatedText$(): Observable<boolean> {
        return this.isAffiliated$.pipe(
            map((hasAffiliations) => {
                return hasAffiliations && this.form.controls.organization.value !== this.ENTER_CAP_AND_KIT_TEXT;
            })
        );
    }

    getLabAffiliationLabel(labAffiliation: LabAffiliation) {
        const lab = 'CAP #: ' + labAffiliation.capNumber;
        const address = [
            labAffiliation.orgName,
            labAffiliation.address1,
            labAffiliation.city,
            labAffiliation.state,
            labAffiliation.postalCode,
        ]
            .filter((field) => !isNullOrUndefined(field))
            .join(', ');

        return lab + ' ' + address;
    }

    assignKitToUser() {
        this.store.dispatch(
            new ClaimCmeCeActions.AssignKitToActivity({
                orgNumber: this.form.controls.capNumber.value,
                kitNumber: this.form.controls.kitNumber.value,
            })
        );
    }

    openContextualHelp() {
        this.store.dispatch(new ClaimCmeCeActions.OpenHelpWindow());
    }

    closeConfirmation() {
        this.store.dispatch(new ClaimCmeCeActions.CloseConfirmationWindow());
    }

    closeErrorDialog() {
        this.store.dispatch(new ClaimCmeCeActions.ClearError());
    }

    closeHelpModal() {
        this.store.dispatch(new ClaimCmeCeActions.CloseHelpWindow());
    }

    ngOnDestroy(): void {
    }
}
